import { render, staticRenderFns } from "./EmailMailCard.vue?vue&type=template&id=6e04f595"
import script from "./EmailMailCard.vue?vue&type=script&lang=js"
export * from "./EmailMailCard.vue?vue&type=script&lang=js"
import style0 from "./EmailMailCard.vue?vue&type=style&index=0&id=6e04f595&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports